// ═══════════════════════════════════════════════════════════════════════════════
// Info pages (Privacy, Terms, PICS, FAQ) — main app chrome when authenticated
// ═══════════════════════════════════════════════════════════════════════════════

import { useAuth } from '../../contexts/AuthContext';
import { MainAppShell } from './MainAppShell';
import { PLAY_BANNER_OFFSET_PADDING_CLASS } from '../../lib/layoutChrome';

type InfoPageShellProps = {
  children: React.ReactNode;
};

export const InfoPageShell = ({ children }: InfoPageShellProps) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <div className={PLAY_BANNER_OFFSET_PADDING_CLASS}>{children}</div>;
  }

  return <MainAppShell>{children}</MainAppShell>;
};
